<template>
	<div class="sp-template">
		<div class="h-title">费用类目</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
					<el-form-item>
						<el-input v-model.trim="conditions.name" placeholder="请输入类目名称" clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button v-if="in_configs(71004)" type="primary" @click="searchSubject()">搜索</el-button>
					</el-form-item>
				</el-form>
			</div>
      <div class="table-button__groups">
        <div class="button-groups">
          <el-button v-if="in_configs(71001)" size="small" @click="showAddDoalog()">添加科目</el-button>
        </div>
      </div>
			<el-table ref="multipleTable" :data="subjectData" stripe border style="width: 100%">
				<el-table-column prop="name" label="科目名称"></el-table-column>
				<el-table-column prop="createAt" label="创建时间"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" size="mini" v-if="in_configs(71002)" @click="handleEdit(scope.row)">编辑</el-button>
						<el-button type="text" size="mini" v-if="in_configs(71003)" @click="deleteSubject(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 弹窗 -->
			<el-dialog title="科目详情" :visible.sync="dialogFormVisible" width="500px" class="fullwidth-form__dialog">
				<el-form :model="subjectForm" size="small" label-width="80px">
					<el-form-item label="科目名称" prop="name">
						<el-input v-model="subjectForm.name" auto-complete="off" placeholder="科目名称"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="dialogFormVisible=false">取 消</el-button>
					<el-button size="small" type="primary" @click="createDriver">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
  data() {
    return {
      conditions: {
        name: ""
      },
      subjectData: [],
      subjectForm: {
        id: 0,
        name: ""
      },
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1, //当前页

      dialogFormVisible: false,
      formLabelWidth: "120px"
    };
  },
  components: {},
  created() {
    this.query();
  },
  computed: {},
  methods: {
    // 初始化查询方法
    query() {
      this.$request1({
        method: 'GET',
        url: '/system/charge-subject',
        params: {
          name: this.conditions.name,
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      })
        .then(response => {
          if (response.data.success) {
            this.total = response.data.total;
            this.subjectData = response.data.data;
          } else {
            this.$message.error(response.data.message);
            this.subjectData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 添加科目
    createDriver() {
      if (this.subjectForm.name.trim() == "") {
        this.$message.error("请输入科目名称");
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/system/charge-subject',
        data: this.subjectForm
      })
        .then(response => {
          if (response.data.success) {
            this.query();
            this.subjectForm.name == "";
            this.subjectForm.id == "";
            this.dialogFormVisible = false;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //搜索
    searchSubject() {
      this.currentPage = 1;
      this.query();
    },
    showAddDoalog() {
      this.subjectForm.id = "";
      this.subjectForm.name = "";
      this.dialogFormVisible = true;
    },
    //编辑
    handleEdit(row) {
      this.subjectForm.id = row.id;
      this.subjectForm.name = row.name;
      this.dialogFormVisible = true;
    },

    //删除
    deleteSubject(rows) {
      this.$confirm("您确定要删除这条费用科目吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let id = rows.id;
          this.$request1({
            method: 'post',
            url: '/system/del/charge-subject',
            data: { subjectId: id }
          })
            .then(response => {
              this.query();
              this.$message({
                message: "删除成功",
                type: "success",
                center: true,
                duration: 1500
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
</style>


// WEBPACK FOOTER //
// src/views/system/chargesubject.vue